// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/hero-career.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.career-page {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  font-family: 'Josefin Sans', sans-serif;
}

/* Hero Section */
.career-hero {
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  color: white;
  padding: 6rem 2rem;
  text-align: center;
  border-radius: 8px;
  margin: 2rem 0;
}

.career-hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.career-hero h1 {
  font-size: 3.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: var(--color-gold);
}

.career-hero p {
  font-size: 1.25rem;
  margin-bottom: 2rem;
  color: white;
}

/* Available Positions Section */
.available-positions {
  padding: 4rem 0;
}

.available-positions h2 {
  font-size: 2.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 3rem;
  color: #333;
}

.positions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.position-card {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.position-header h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
}

.position-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.position-meta span {
  background: #f5f5f5;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  color: #666;
}

.position-description {
  color: #555;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.position-details {
  margin-bottom: 2rem;
}

.position-details h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
  text-align: left;
}

.position-details ul {
  list-style-type: none;
  padding: 0;
  text-align: left;
}

.position-details li {
  margin-bottom: 0.5rem;
  padding-left: 1.5rem;
  position: relative;
  color: #555;
  text-align: left;
}

.position-details li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: var(--color-gold);
}

/* Qualifications Section */
.qualifications {
  padding: 4rem 0;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 2rem 0;
}

.qualifications h2 {
  font-size: 2.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 1.5rem;
  color: #333;
}

.qualifications > p {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 3rem;
  color: #555;
  line-height: 1.6;
}

.qualifications-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 0 2rem;
}

.qualification-section h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1.5rem;
}

.qualification-section ul {
  list-style-type: none;
  padding: 0;
  text-align: left;
}

.qualification-section li {
  margin-bottom: 0.75rem;
  padding-left: 1.5rem;
  position: relative;
  color: #555;
  text-align: left;
}

/* Essential qualifications checkmark */
.qualification-section:first-child li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: var(--color-gold);
}

/* Preferred qualifications checkmark */
.qualification-section:last-child li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #888;
}

/* Apply Button */
.apply-button {
  background: var(--color-gold);
  color: #526015;
  border: none;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Josefin Sans', sans-serif;
}

.apply-button:hover {
  background: var(--color-green-light);
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .career-hero {
    padding: 4rem 1rem;
  }

  .career-hero h1 {
    font-size: 2.5rem;
  }

  .available-positions h2 {
    font-size: 2rem;
  }

  .position-card {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .career-hero h1 {
    font-size: 2rem;
  }

  .career-hero p {
    font-size: 1.1rem;
  }

  .position-meta {
    flex-direction: column;
    gap: 0.5rem;
  }

  .position-meta span {
    width: fit-content;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/Career.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA,iBAAiB;AACjB;EACE,4GAAqG;EACrG,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,wBAAwB;AAC1B;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".career-page {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1rem;\n  font-family: 'Josefin Sans', sans-serif;\n}\n\n/* Hero Section */\n.career-hero {\n  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('../assets/hero-career.jpg');\n  background-size: cover;\n  background-position: center;\n  color: white;\n  padding: 6rem 2rem;\n  text-align: center;\n  border-radius: 8px;\n  margin: 2rem 0;\n}\n\n.career-hero-content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.career-hero h1 {\n  font-size: 3.5rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: var(--color-gold);\n}\n\n.career-hero p {\n  font-size: 1.25rem;\n  margin-bottom: 2rem;\n  color: white;\n}\n\n/* Available Positions Section */\n.available-positions {\n  padding: 4rem 0;\n}\n\n.available-positions h2 {\n  font-size: 2.5rem;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 3rem;\n  color: #333;\n}\n\n.positions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.position-card {\n  background: white;\n  border-radius: 8px;\n  padding: 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.position-header h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 1rem;\n}\n\n.position-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.position-meta span {\n  background: #f5f5f5;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.position-description {\n  color: #555;\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n}\n\n.position-details {\n  margin-bottom: 2rem;\n}\n\n.position-details h4 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 1rem;\n  text-align: left;\n}\n\n.position-details ul {\n  list-style-type: none;\n  padding: 0;\n  text-align: left;\n}\n\n.position-details li {\n  margin-bottom: 0.5rem;\n  padding-left: 1.5rem;\n  position: relative;\n  color: #555;\n  text-align: left;\n}\n\n.position-details li::before {\n  content: \"•\";\n  position: absolute;\n  left: 0;\n  color: var(--color-gold);\n}\n\n/* Qualifications Section */\n.qualifications {\n  padding: 4rem 0;\n  background: #f9f9f9;\n  border-radius: 8px;\n  margin: 2rem 0;\n}\n\n.qualifications h2 {\n  font-size: 2.5rem;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 1.5rem;\n  color: #333;\n}\n\n.qualifications > p {\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto 3rem;\n  color: #555;\n  line-height: 1.6;\n}\n\n.qualifications-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  padding: 0 2rem;\n}\n\n.qualification-section h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 1.5rem;\n}\n\n.qualification-section ul {\n  list-style-type: none;\n  padding: 0;\n  text-align: left;\n}\n\n.qualification-section li {\n  margin-bottom: 0.75rem;\n  padding-left: 1.5rem;\n  position: relative;\n  color: #555;\n  text-align: left;\n}\n\n/* Essential qualifications checkmark */\n.qualification-section:first-child li::before {\n  content: \"✓\";\n  position: absolute;\n  left: 0;\n  color: var(--color-gold);\n}\n\n/* Preferred qualifications checkmark */\n.qualification-section:last-child li::before {\n  content: \"✓\";\n  position: absolute;\n  left: 0;\n  color: #888;\n}\n\n/* Apply Button */\n.apply-button {\n  background: var(--color-gold);\n  color: #526015;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 25px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Josefin Sans', sans-serif;\n}\n\n.apply-button:hover {\n  background: var(--color-green-light);\n  transform: translateY(-2px);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .career-hero {\n    padding: 4rem 1rem;\n  }\n\n  .career-hero h1 {\n    font-size: 2.5rem;\n  }\n\n  .available-positions h2 {\n    font-size: 2rem;\n  }\n\n  .position-card {\n    padding: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .career-hero h1 {\n    font-size: 2rem;\n  }\n\n  .career-hero p {\n    font-size: 1.1rem;\n  }\n\n  .position-meta {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .position-meta span {\n    width: fit-content;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
